var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmsImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 128,
    viewBox: "0 0 148 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1121_8188)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.5,
    y: 13.5,
    width: 45.0072,
    height: 85.4527,
    rx: 9.5,
    fill: "white",
    stroke: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.7932,
    y: 14.7891,
    width: 42.4222,
    height: 82.8754,
    rx: 8,
    fill: "#19184A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.704 16.6729C107.388 16.6729 107.079 16.7663 106.817 16.9414C106.554 17.1165 106.35 17.3654 106.229 17.6565C106.108 17.9477 106.076 18.2681 106.138 18.5772C106.2 18.8863 106.352 19.1702 106.575 19.3931C106.798 19.6159 107.083 19.7677 107.392 19.8292C107.702 19.8907 108.023 19.8591 108.315 19.7385C108.606 19.6179 108.856 19.4137 109.031 19.1516C109.207 18.8896 109.3 18.5815 109.3 18.2663C109.3 17.8437 109.132 17.4384 108.833 17.1396C108.533 16.8407 108.127 16.6729 107.704 16.6729Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.218 56.6327C112.218 54.0497 110.204 48.604 102.609 49.0229L102.609 94.5182C102.609 97.1012 104.735 99.1951 107.357 99.1951H107.47C110.092 99.1951 112.218 97.1012 112.218 94.5182V56.6327Z",
    fill: "#E28F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.079 72.3789H116.966C114.344 72.3789 112.218 74.4728 112.218 77.0558V94.5042C112.218 97.0871 114.344 99.181 116.966 99.181H117.079C119.701 99.181 121.827 97.0871 121.827 94.5042V77.0558C121.827 74.4728 119.701 72.3789 117.079 72.3789Z",
    fill: "#E28F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.687 75.2021H126.575C123.952 75.2021 121.827 77.2961 121.827 79.879V94.5185C121.827 97.1015 123.952 99.1954 126.575 99.1954H126.687C129.31 99.1954 131.435 97.1015 131.435 94.5185V79.879C131.435 77.2961 129.31 75.2021 126.687 75.2021Z",
    fill: "#E28F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.72 77.8857H135.65C133.315 77.8857 131.422 79.7504 131.422 82.0507V95.0297C131.422 97.3299 133.315 99.1946 135.65 99.1946H135.72C138.056 99.1946 139.949 97.3299 139.949 95.0297V82.0507C139.949 79.7504 138.056 77.8857 135.72 77.8857Z",
    fill: "#E28F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.185 118.29L116.601 122.348C114.756 122.348 116.434 113.665 114.73 112.97C113.025 112.275 112.41 117.879 111.106 116.594C109.801 115.309 104.328 115.485 103.622 113.806C102.916 112.127 102.553 110.328 102.553 108.511V97.3027H139.949L139.949 105.722C139.934 109.37 140.097 113.775 133.654 117.399C131.037 119.98 126.889 118.272 123.185 118.29Z",
    fill: "#E28F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.252 110.974H108.735V138.118H133.252V110.974Z",
    fill: "#E28F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0049 80.4573L97.8405 105.988C97.8405 105.988 99.0263 109.749 101.442 113.776C103.858 117.802 110.703 119.413 110.703 119.413L124.605 113.083L119.009 103.092L127.372 95.8042L109.047 104.455L98.5063 84.0946C98.5063 84.0946 95.0372 78.959 88.0049 80.4573Z",
    fill: "#E28F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.949 98.9624V90.6603C139.949 89.5593 139.505 88.5035 138.714 87.725C137.924 86.9465 136.852 86.5092 135.734 86.5092H135.65C134.532 86.5092 133.46 86.9465 132.67 87.725C131.88 88.5035 131.436 89.5593 131.436 90.6603V89.0967C131.436 88.4825 131.313 87.8744 131.074 87.3069C130.835 86.7395 130.486 86.2239 130.045 85.7897C129.604 85.3554 129.08 85.0109 128.504 84.7758C127.928 84.5408 127.311 84.4198 126.687 84.4198H126.589C125.33 84.4198 124.122 84.9126 123.231 85.7897C122.341 86.6667 121.841 87.8563 121.841 89.0967V87.713C121.837 86.4714 121.334 85.2818 120.441 84.4051C119.548 83.5284 118.339 83.0361 117.078 83.0361H116.98C115.722 83.0398 114.516 83.5337 113.627 84.41C112.737 85.2863 112.236 86.4738 112.232 87.713C112.232 86.4726 111.732 85.283 110.841 84.406C109.951 83.5289 108.743 83.0361 107.484 83.0361H107.371C106.111 83.0361 104.902 83.5284 104.009 84.4051C103.116 85.2818 102.613 86.4714 102.609 87.713V98.9624H139.949Z",
    fill: "#E28F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 26C9 22.6863 11.6863 20 15 20H93C96.3137 20 99 22.6863 99 26V68C99 71.3137 96.3137 74 93 74H15C11.6863 74 9 71.3137 9 68V26Z",
    fill: "#BAE0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99 29L99 39L110 39L99 29Z",
    fill: "#BAE0FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.625,
    y: 35.9375,
    width: 61.0569,
    height: 19.7537,
    rx: 2,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.4218,
    y: 43.6426,
    width: 39.1939,
    height: 4.45386,
    rx: 2.22693,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.357 47.1367L34.854 45.2817C35.1285 44.2572 34.5205 43.2041 33.496 42.9296C32.4715 42.655 31.4184 43.263 31.1439 44.2876L29.9012 48.9252C29.6267 49.9497 30.2347 51.0028 31.2592 51.2773C31.7297 51.4034 32.2062 51.3434 32.6105 51.1423C32.8587 51.019 33.0797 50.8425 33.2554 50.6234M32.999 44.7846L32.5019 46.6397C32.2274 47.6642 32.8354 48.7173 33.8599 48.9918C34.8844 49.2663 35.9375 48.6583 36.212 47.6338L37.4547 42.9962C37.7292 41.9716 37.1212 40.9186 36.0967 40.644C35.6262 40.518 35.1497 40.578 34.7454 40.779C34.4972 40.9024 34.2762 41.0788 34.1005 41.2979",
    stroke: "#5283EC",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1121_8188"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 148,
    height: 128,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsImage);
export default __webpack_public_path__ + "static/media/smsImage.2582ca58f51029b19d956009c5e6bd6c.svg";
export { ForwardRef as ReactComponent };